import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import ThankyouStyle from "./Thankyou.module.css";
import Wrapper from "./Wrapper";

import { Card } from "react-bootstrap";
import ContactStyle from "../Contact/Contact.module.css";

const ThankyouGeneral = ({ sendEmailHandler }) => {
  const { firstName } = useParams();

  const formStyle = ContactStyle.formStyle;
  const contact = ContactStyle.contact;
  const contactTitle = ContactStyle.contactTitle;
  const spanText = ContactStyle.spanText;

  return (
    <>
      <div className={contact}>
        <Card
          className={formStyle}
          style={{
            color: "white",
            textAlign: "center",
            background: "rgb(2 2 2 / 72%)",
          }}
        >
          <p className={contactTitle}>
            Thank <span className={spanText}>You </span>
          </p>
          <h1>
            Hello
            <b> {firstName},</b>
          </h1>
          <p>
            Thanks for reaching out! We’ve received your submission and will
            contact you soon. <br />
            <br />
          </p>

          <div style={{ textAlign: "center" }}>
            <h3><em>Excited for the ACBC Conference?</em></h3>
            <p>
              Now you can make a personal post in just a few clicks and tell the
              world!
            </p>
            <Button
              href="https://acbc-connect.com"
              style={{
                marginTop: "1rem",
                background: "#d4ba66",
                border: "none",
                color: "black",
                width: "50%",
              }}
            >
              SHARE YOUR ATTENDING!
            </Button>

            <br />

            <Button
              style={{
                marginTop: "1rem",
                background: "transparent",
                border: "none",
                color: "white",
                width: "50%",
                textDecoration: "underline",
              }}
              href="/"
            >
              BACK TO WEBSITE
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
};
export default ThankyouGeneral;
